import { render, staticRenderFns } from "./SolarPanels.vue?vue&type=template&id=49486996&"
import script from "./SolarPanels.vue?vue&type=script&lang=js&"
export * from "./SolarPanels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports